import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormControl,
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputComponent,
      multi: true,
    },
  ],
})
export class InputComponent implements ControlValueAccessor {
  set value(val: string) {
    this.val = val;
  }
  @Input() placeholder = '';
  @Input() hintText = '';
  @Input() type = 'default';
  @Input() control: FormControl;
  @Input() prefixIcon: string;
  @Input() suffixIcon: string;
  @Input() suffixText: string;
  @Input() showErrors = false;
  @Input() hint: string;
  @Input() classes: string = '';
  @Input() isRequired: boolean = false;
  hide = true;
  val = '';
  @Input() showHeader: boolean = false;

  constructor() { }

  @Output() changed: EventEmitter<string> = new EventEmitter();
  @Output() suffixTextClicked: EventEmitter<boolean> = new EventEmitter();

  onChange: any = () => { };
  onTouch: any = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void { }

  onKeyUp(event: any) {
    this.changed.emit(event.target.value);
  }

  keyInputEmitted(value: string) {
    if (this.control.value === null) {
      this.control.setValue('');
    }

    if (value === 'Backspace') {
      if (this.control.value.length > 0) {
        this.control.setValue(
          this.control.value.substring(0, this.control.value.length - 1)
        );
      }
    } else {
      this.control.setValue(this.control.value + value);
    }
  }

  onSuffixTextClicked() {
    this.suffixTextClicked.emit(true);
  }
}
